$(function() {
    $(document).on("click", "a", function() {
        if (("noLoading" in this.dataset)) {
            return;
        }
        $('body').addClass('is-loading');
        setTimeout(function() {
            $('body').removeClass('is-loading');
        }, 7000);
    });
    $(document).on("submit", "form", function() {
        if (("noLoading" in this.dataset)) {
            return;
        }
        $('body').addClass('is-loading');
        setTimeout(function() {
            $('body').removeClass('is-loading');
        }, 7000);
    });
    $('body').removeClass('is-loading-fill');
    $('.static').addClass('static--show');
});
